import { createRef, PureComponent } from 'react'
import IntersectionObserver from 'intersection-observer-polyfill'

import * as modularRepository from 'scripts/api/modular'

import { AbTestSortModule } from 'reactUtils/ab-test'

import { ModulesError } from './components/ModulesError'
import { ModulesSpinner } from './components/ModulesSpinner'
import { ModulesLoading } from './components/ModulesLoading'
import ModulesDictionary from './components/ModulesDictionary'
import ModularProviderMethods from './providers/ModularProviderMethods'

class Modular extends PureComponent {
  constructor (props) {
    super(props)

    this.container = createRef(null)
    this.containerModuleList = createRef(null)

    this.scrollObserver = this.createScrollObserver()

    this.state = {
      hasError: false,
      isLoading: true,
      modules: [],
      page: 1,
      pageCount: 1
    }
  }

  async componentDidMount () {
    await this.getPageModules()

    this.setState({ isLoading: false })

    this.scrollObserver.observe(this.containerModuleList.current)
  }

  getPageModules = async () => {
    const { modularContentId } = this.props
    const { page, modules } = this.state

    try {
      const { data } = await modularRepository.getModules(
        modularContentId,
        page
      )

      const items = AbTestSortModule(data.results, modularContentId, page)

      this.setState({
        modules: [...modules, ...items],
        pageCount: data.metadata.pageCount
      })
    } catch (err) {
      this.setState({ hasError: true })
      console.error(err)
    }
  }

  createScrollObserver = () => {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.9
    }

    return new IntersectionObserver(([entry]) => {
      const { page, pageCount } = this.state
      const hasPagination = page < pageCount

      if (entry.isIntersecting && hasPagination) {
        this.setState({ page: page + 1 }, async () => {
          await this.getPageModules()
          this.updateScrollObserver()
        })
      }
    }, options)
  }

  /**
   * this method is necessary because when updating the number
   * of modules the observed element value does not change automatically
   */
  updateScrollObserver = () => {
    this.scrollObserver.disconnect()
    this.scrollObserver.observe(this.containerModuleList.current)
  }

  setFamilyPageABTestModules = data => {
    const items = [...data]

    const abTestPayload = JSON.parse(
      sessionStorage.getItem('family_ab_recommended')
    )

    if (abTestPayload) {
      items.splice(abTestPayload.index, 0, abTestPayload)
    }

    return items
  }

  renderModules = () => {
    const items =
      this.props.pageType === 'category/modular-family'
        ? this.setFamilyPageABTestModules(this.state.modules)
        : this.state.modules

    return items.map((item, index) => {
      const contentName = item.type === 'children' && {
        contentName: this.props.contentName
      }

      const data = { ...item, ...contentName }

      return (
        <div key={index} ref={this.containerModuleList}>
          <ModulesDictionary data={data} />
        </div>
      )
    })
  }

  render () {
    const { hasError, isLoading, page, pageCount } = this.state

    if (hasError) {
      return <ModulesError />
    }

    if (isLoading) {
      return <ModulesLoading defaultFallback={this.props.fallback} />
    }

    return (
      <ModularProviderMethods isBlackWeekend={this.props.isBlackWeekend}>
        <div ref={this.container}>{this.renderModules()}</div>
        {page < pageCount && <ModulesSpinner />}
      </ModularProviderMethods>
    )
  }
}

export default Modular
